// extracted by mini-css-extract-plugin
export default {"messageList":"MphljcLn8A9m_4oEfFtQ","bottomBlock":"Phhg77Db6SyHVcXQ8Asq","loaderWrap":"WZQXPXbGPIkc6EgpEMAZ","loader":"NLkbxQIriFIOLaw0vhDI"};